// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as BellOutlineComponent} from './BellOutline.svg';

import Icon, { TIconProps } from '../Icon';

export const IconBellOutline = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <BellOutlineComponent/>
  </Icon>
));
